import { ERROR_TYPE } from "@smartrr/shared/types";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

import { LoginError } from "../../types";
import { Timer } from "../Timer";

export interface ISignInFooter {
  loginError?: LoginError;
  shopifyDomain: string;
}

// @todo: could use a little clean up / breaking otu
export const SignInFooter = ({ loginError, shopifyDomain }: ISignInFooter) => {
  const style = {
    color: loginError ? "red" : "initial",
  };

  const footerText = loginError ? "No account found." : "No account?";

  const createAccountLink = {
    url: `https://${shopifyDomain}/account/register`,
    label: loginError
      ? typedLocalize("passwordlessLogin.createOne", {
          ending: "?",
        })
      : typedLocalize("passwordlessLogin.createOne", {
          ending: "",
        }),
  };

  const renderLocalizedErrorMessage = (loginError: LoginError) => {
    return (
      <p>
        {Boolean(loginError) && <span>{loginError.localizedError}</span>}
        {Boolean(loginError.showTimer) && <Timer initialMinute={loginError.initialMinute} initialSeconds={0} />}
      </p>
    );
  };

  const showCreateAccountMessage = (loginError: LoginError) =>
    (loginError && loginError.errorType === ERROR_TYPE.NOT_FOUND_USER) ||
    loginError.errorType === ERROR_TYPE.WRONG_EMAIL;

  const renderLoginInfoMessage = (loginError?: LoginError) => {
    if (!loginError) {
      return (
        <span style={style}>
          {typedLocalize("passwordlessLogin.noAccount")}{" "}
          <a style={{ display: "inline", color: "inherit", fontSize: "inherit" }} href={createAccountLink.url}>
            {typedLocalize("passwordlessLogin.createOne", {
              ending: "",
            })}
          </a>
        </span>
      );
    } else if (showCreateAccountMessage(loginError)) {
      return (
        <span style={style}>
          {footerText}{" "}
          <a style={{ display: "inline", color: "inherit", fontSize: "inherit" }} href={createAccountLink.url}>
            {createAccountLink.label}
          </a>
        </span>
      );
    }
    return <span style={style}>{renderLocalizedErrorMessage(loginError)}</span>;
  };
  return <footer style={{ marginTop: "20px" }}>{renderLoginInfoMessage(loginError)}</footer>;
};
